/** Hex-цвет из ColorValue (кастом `color_hex` или пресет по id). */
export function resolveColorValue(value, presets) {
    if (!value)
        return undefined;
    if ("color_hex" in value)
        return value.color_hex;
    if ("preset_id" in value) {
        return presets.find((p) => p.id === value.preset_id)?.color_hex;
    }
    return undefined;
}
/** Текст из TextValue (кастом `text` или пресет по id). */
export function resolveTextValue(value, presets) {
    if (!value)
        return undefined;
    if ("text" in value)
        return value.text;
    if ("preset_id" in value) {
        return presets.find((p) => p.id === value.preset_id)?.text;
    }
    return undefined;
}
/** Заголовок из TitleValue (кастом `title` или пресет-повод по id). */
export function resolveTitleValue(value, presets) {
    if (!value)
        return undefined;
    if ("title" in value)
        return value.title;
    if ("preset_id" in value) {
        return presets.find((p) => p.id === value.preset_id)?.title;
    }
    return undefined;
}
/** Пресет-картинка (паттерн/иконка) по id из соответствующего списка. */
export function findImagePreset(presetId, list) {
    if (presetId == null)
        return undefined;
    return list.find((p) => p.id === presetId);
}
/** Пустой каталог пресетов (для fallback, пока не загрузился). */
export function emptyPresets() {
    return {
        backgrounds: [],
        patterns: [],
        greetings: [],
        text_colors: [],
        icons: [],
        occasions: [],
        wishes: [],
        box_colors: [],
        fonts: [],
        animations: [],
    };
}
